import { NeoTypes } from "../../AppServices";
import { Globals } from "../../Misc";
var MenuUtils = /** @class */ (function () {
    function MenuUtils() {
    }
    MenuUtils.showContextMenu = function (items, positionArg) {
        var globalState = Globals.appService.get(NeoTypes.UI.GlobalContextMenuState);
        var position;
        if (positionArg instanceof HTMLElement) {
            var element = positionArg, offsetLeft = 0, offsetTop = 0;
            var height = element.getBoundingClientRect().height;
            do {
                offsetLeft += element.offsetLeft;
                offsetTop += element.offsetTop;
                element = (element && element.offsetParent instanceof HTMLElement) ? element.offsetParent : null;
            } while (element);
            position = { x: offsetLeft, y: offsetTop + height };
        }
        else if (positionArg.pageX) {
            var mouseEvent = positionArg;
            position = { x: mouseEvent.pageX + 1, y: mouseEvent.pageY };
        }
        else {
            position = positionArg;
        }
        globalState.items = items;
        globalState.position = position;
    };
    MenuUtils.hideContextMenu = function () {
        Globals.appService.get(NeoTypes.UI.GlobalContextMenuState).position = null;
    };
    return MenuUtils;
}());
export { MenuUtils };
